import { Component, HostListener, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { RobotsMetaService } from './services/common/robots-meta.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ToastModule,
  ],
  templateUrl: './app.component.html',
})
export class AppComponent {
  private readonly robotsMeta = inject(RobotsMetaService);

  constructor() {
    this.robotsMeta.start();
  }

  @HostListener('window:dragover', ['$event'])
  @HostListener('window:drop', ['$event'])
  preventWindowFileDrop(event: DragEvent): void {
    event.preventDefault();
  }
}
